module.exports = __webpack_public_path__ + "static/media/Financial_Report_2024_2025.69ab60a2.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/25-26/Financial_Report_2024_2025.pdf
// module id = 243
// module chunks = 0